import { Box, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';
import ErrorMessage from '../errorMessage';
import { useElementSize } from '@custom-react-hooks/use-element-size';

type Props = {
  imageDataUrl: string;
  maxHeight?: number;
  showLabel?: boolean;
  label?: string;
  error?: string;
};

const ImageViewer = ({ imageDataUrl, showLabel = true, label, error, maxHeight = 0 }: Props) => {
  const [headerRef, headerSize] = useElementSize();

  const computedMaxHeight =
    maxHeight > 0
      ? Math.max(100, maxHeight - (headerSize.height > 0 ? headerSize.height + 5 : 0))
      : 400;

  return (
    <Card variant="outlined" sx={{ border: label || error ? 1 : 0, borderColor: 'divider', width: '100%', maxWidth: '100%' }}>
      {showLabel && (label || error) && (
        <CardHeader
          title={
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems={'center'}>
              <Typography sx={{ textOverflow: 'ellipsis', fontWeight: 600, fontSize: '0.8rem' }}>{label}</Typography>
            </Stack>
          }
          subheader={error && <ErrorMessage error={error} />}
          sx={{ p: 1 }}
          ref={headerRef}
          disableTypography
        />
      )}
      {showLabel && (label || error) && <Divider />}
      <CardContent sx={{ p: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', '&:last-child': { pb: 1 } }}>
        <Box
          component="img"
          src={imageDataUrl}
          alt={label || 'Image preview'}
          sx={{
            maxWidth: '100%',
            maxHeight: computedMaxHeight,
            objectFit: 'contain',
            borderRadius: 1,
          }}
        />
      </CardContent>
    </Card>
  );
};

export default ImageViewer;
